import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { authManager } from 'redux/action/auths';
import AuthEditMain from './authEdit/AuthEditMain';
import AuthListMain from './authList/AuthListMain';
import { AuthContainer } from './ConfigAuth.css';

const ConfigAuth = () => {
  const [selectAuth, setSelectAuth] = useState(null);
  const dispatch = useDispatch();
  const auths = useSelector((store) => store.auths);

  useEffect(() => {
    dispatch(authManager());
  }, []);

  return (
    <AuthContainer>
      <AuthListMain auths={auths.auth} selectAuth={selectAuth} setSelectAuth={setSelectAuth} />
      <AuthEditMain auths={auths.auth} selectAuth={selectAuth} setSelectAuth={setSelectAuth} />
    </AuthContainer>
  );
};

export default ConfigAuth;
